import { render, staticRenderFns } from "./tankerDetailDialog.vue?vue&type=template&id=29b890fc"
import script from "./tankerDetailDialog.vue?vue&type=script&lang=js"
export * from "./tankerDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./tankerDetailDialog.vue?vue&type=style&index=0&id=29b890fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports